import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { connect } from "react-redux";
import {
  StyledAdvEditorToolbarFormatGroup,
  StyledAdvEditorToolbarRow,
} from "../../../styled/details/stylesDetails";
import { easingOptions, predefinedSpeeds } from "./defaultSlideTransitions";
import { ENTER_ANIMATION } from "../../../../_actions/types";
import { enterEffects, exitEffects } from "./defaultLayerAnimations";
import { TldrCollapsableAction } from "../../../common/statelessView";
import TldrAnimationOptions from "../../../../_components/common/TldrAnimationOptions";
import StudioAnimationCollection from "./StudioAnimationCollection";
import { MINIMUM_STILL_DURATION, STILL } from "../../constants";
import { FaEdit, FaPlay, FaTrash } from "react-icons/fa";
import { Button, ButtonGroup, Switch } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { GROUP_LEVEL_ANIMATIONS } from "../../constants";
import { setCurrentPlayingAnimation } from "apps/simplified-web/src/_actions/animationActions";

export class StudioLayerAnimationControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: props.index,
      animationStore:
        props.animation?.motion === ENTER_ANIMATION
          ? enterEffects
          : exitEffects,
      loop: props.animation?.loop,
      motion: props.animation?.motion,
      trans_duration: props.animation?.trans_duration, // Normal
      animationType: props.animation?.type,
      easing: props.animation?.easing,
      delay: props.animation?.delay,
      collapse: true,
      checked: props.animation?.loop,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { animation } = props;
    if (
      animation?.loop !== state.loop ||
      animation?.trans_duration !== state.trans_duration ||
      animation?.type !== state.animationType ||
      animation?.delay !== state.delay ||
      animation?.easing !== state.easing ||
      props?.index !== state.index ||
      props?.index !== state.index ||
      props.animation?.motion !== state?.motion
    ) {
      return {
        loop: animation?.loop,
        trans_duration: animation?.trans_duration,
        animationType: animation?.type,
        delay: animation?.delay,
        easing: animation?.easing,
        animationStore:
          props.selectedTab === ENTER_ANIMATION ? enterEffects : exitEffects,
        motion: props.animation?.motion,
        index: props.index,
        checked: animation?.loop,
      };
    }
    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !_.isEqual(this.state, nextState) ||
      this.props.selectedTab !== nextProps.selectedTab ||
      !_.isEqual(this.props.allAnimations, nextProps.allAnimations)
    );
  }

  handleToggleChange = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  onDeleteAnimation = () => {
    const { layers, editor, canvasRef } = this.props;
    const currentAnimations = layers[editor.activeElement.id].payload.animation;
    const selectedAnimation = currentAnimations[this.state.index];

    let stillAnimation = currentAnimations[1];
    if (this.state.index === 0) {
      stillAnimation["start_time"] = selectedAnimation["start_time"];
    } else {
      stillAnimation["end_time"] = selectedAnimation["end_time"];
    }
    stillAnimation["trans_duration"] =
      stillAnimation["end_time"] - stillAnimation["start_time"];

    currentAnimations.splice(this.state.index, 1);
    if (currentAnimations.length === 1) {
      canvasRef.handler.removeKey("animation");
      return;
    }
    canvasRef.handler.set("animation", currentAnimations);
  };

  previewEffect = async () => {
    const { editor, canvasRef, layers, pages, setCurrentPlayingAnimation } =
      this.props;
    const currentAnimation = pages[editor.activePage.id].payload.animation;
    const currentAnimations = layers[editor.activeElement.id].payload.animation;

    setCurrentPlayingAnimation(currentAnimations.map((item) => item.parentId));
    await canvasRef.handler.animationHandler.previewAndUpdate(
      editor.activeElement,
      currentAnimations,
      this.state.index,
      false,
      currentAnimation.duration
    );
    setCurrentPlayingAnimation(null);
  };

  actionCallback = (action) => {
    if (action === "delete") {
      this.onDeleteAnimation();
    } else if (action === "edit") {
    } else if (action === "play") {
      this.previewEffect();
    }
  };

  onOptionChange = async (adjustment) => {
    const { editor, canvasRef, layers, pages, setCurrentPlayingAnimation } =
      this.props;
    const currentAnimation = pages[editor.activePage.id].payload.animation;
    const currentAnimations = layers[editor.activeElement.id].payload.animation;
    const selectedAnimation = currentAnimations[this.state.index];
    selectedAnimation["type"] = adjustment.type;

    this.setState({
      ...this.state,
      animationType: adjustment.type,
    });

    const update = this.state.animationType !== adjustment.type;

    setCurrentPlayingAnimation(currentAnimations.map((item) => item.parentId));
    await canvasRef.handler.animationHandler.previewAndUpdate(
      editor.activeElement,
      currentAnimations,
      this.state.index,
      update,
      currentAnimation.duration
    );
    setCurrentPlayingAnimation(null);
  };

  onChangeControl = async (key, newValue) => {
    const { editor, layers, canvasRef, pages, setCurrentPlayingAnimation } =
      this.props;
    const currentAnimation = pages[editor.activePage.id].payload.animation;
    const currentAnimations = layers[editor.activeElement.id].payload.animation;

    currentAnimations[this.state.index][key] = newValue;
    // console.log("current animations ", currentAnimations);
    // if (key === "loop") {
    //   canvasRef.handler.set("animation", currentAnimations);
    //   return;
    // }
    setCurrentPlayingAnimation(currentAnimations.map((item) => item.parentId));
    await canvasRef.handler.animationHandler.previewAndUpdate(
      editor.activeElement,
      currentAnimations,
      this.state.index,
      true,
      currentAnimation.duration
    );
    setCurrentPlayingAnimation(null);
  };

  onSpeedChange = async (speed) => {
    this.setState({
      ...this.state,
      trans_duration: speed.value,
    });

    const { layers, editor, canvasRef, pages, setCurrentPlayingAnimation } =
      this.props;
    const currentAnimation = pages[editor.activePage.id].payload.animation;
    const currentAnimations = layers[editor.activeElement.id].payload.animation;
    const selectedAnimation = currentAnimations[this.state.index];

    let stillAnimationDuration = 0;
    for (const a of currentAnimations) {
      if (a.type === STILL) {
        stillAnimationDuration += a.trans_duration;
      }
    }

    let availableSpeedForAnimation =
      stillAnimationDuration +
      (selectedAnimation?.trans_duration ?? 0) -
      MINIMUM_STILL_DURATION;

    const stillAnimationDurationAdjustment =
      selectedAnimation?.trans_duration -
      Math.min(availableSpeedForAnimation, speed.value);

    let updatedAnimations = currentAnimations.map((a, idx) => {
      let trans_duration = a.trans_duration;
      if (a.motion === STILL) {
        trans_duration = a.trans_duration + stillAnimationDurationAdjustment;
      } else if (idx === this.state.index) {
        trans_duration = Math.min(availableSpeedForAnimation, speed.value);
      }

      return { ...a, trans_duration };
    });

    // Rebuild the animations
    let prevOffset =
      updatedAnimations && updatedAnimations.length
        ? updatedAnimations[0].start_time
        : 0;
    updatedAnimations = updatedAnimations.map((a) => {
      const start_time = prevOffset;
      const end_time = prevOffset + a.trans_duration;
      prevOffset = end_time;
      return {
        ...a,
        start_time,
        end_time,
      };
    });

    // if (this.state.index === 0) {
    //   selectedAnimation["end_time"] =
    //     selectedAnimation["start_time"] + selectedAnimation["trans_duration"];
    //
    //   let stillAnimation = currentAnimations[1];
    //   selectedAnimation["trans_duration"] = speed.value;
    //   stillAnimation["start_time"] = selectedAnimation["end_time"];
    //   stillAnimation["trans_duration"] =
    //     stillAnimation["end_time"] - stillAnimation["start_time"];
    // } else {
    //   let stillAnimation = currentAnimations[0];
    //   selectedAnimation["trans_duration"] = speed.value;
    //   selectedAnimation["start_time"] =
    //     selectedAnimation["end_time"] - selectedAnimation["trans_duration"];
    //
    //   stillAnimation["end_time"] = selectedAnimation["start_time"];
    //   stillAnimation["trans_duration"] =
    //     stillAnimation["end_time"] - stillAnimation["start_time"];
    // }
    //
    // // entryAnimation["trans_duration"] = speed.value;
    // // entryAnimation["end_time"] =
    // // entryAnimation["start_time"] + entryAnimation["trans_duration"];
    // // // On loop just change the speed.
    // // if (entryAnimation.loop === true) {
    // //   const updatedAnimation = [entryAnimation];
    // //   canvasRef.handler.animationHandler.previewAndUpdate(
    // //     editor.activeElement.id,
    // //     updatedAnimation
    // //   );
    // //   return;
    // // }
    const update = speed.value !== this.state.trans_duration;

    setCurrentPlayingAnimation(updatedAnimations.map((item) => item.parentId));
    await canvasRef.handler.animationHandler.previewAndUpdate(
      editor.activeElement,
      updatedAnimations,
      this.state.index,
      update,
      currentAnimation.duration
    );
    setCurrentPlayingAnimation(null);
  };

  onLoopSwitchChange = () => {
    this.setState({
      ...this.state,
      checked: !this.state.checked,
      loop: !this.state.checked,
    });
    this.onChangeControl("loop", !this.state.checked);
  };

  onEasingChange = (selected) => {
    this.setState({
      ...this.state,
      easing: selected.value,
    });
    this.onChangeControl("easing", selected.value);
  };

  onChangeDuration = (delay) => {
    this.setState({
      ...this.state,
      delay: delay.value,
    });
    this.onChangeControl("delay", delay[0] * 1000);
  };

  render() {
    const {
      checked,
      trans_duration,
      animationType,
      easing,
      animationStore,
      collapse,
    } = this.state;
    const {
      editor,
      animation,
      onChangeAnimation,
      selectedTab,
      allAnimations,
      t,
    } = this.props;

    const selectedAnimations = animationStore.filter(function (adjustment) {
      return animationType ? animationType.includes(adjustment.id) : false;
    });

    let stillAnimationDuration = 0;
    if (allAnimations) {
      for (const a of allAnimations) {
        if (a.type === STILL) {
          stillAnimationDuration += a.trans_duration;
        }
      }
    }

    let availableSpeedForAnimation =
      stillAnimationDuration +
      (animation?.trans_duration ?? 0) -
      MINIMUM_STILL_DURATION;

    const variants =
      selectedAnimations.length > 0 && selectedAnimations[0].variants.length > 1
        ? selectedAnimations[0].variants.map((dir, index) => {
            return (
              <Button
                variant={animationType === dir.type ? "solid" : "secondary"}
                size="sm"
                key={index}
                onClick={() => this.onOptionChange(dir)}
              >
                {dir.title}
              </Button>
            );
          })
        : null;

    const presetOptions = predefinedSpeeds.map((newSpeed, index) => {
      return (
        <Button
          variant={
            newSpeed.start <= trans_duration && trans_duration < newSpeed.end
              ? "solid"
              : "secondary"
          }
          size="sm"
          key={index}
          onClick={() => this.onSpeedChange(newSpeed)}
          disabled={newSpeed.value > availableSpeedForAnimation}
        >
          {newSpeed.title}
        </Button>
      );
    });

    // if (selectedAnimations.characterLevel) {
    //   return null;
    // }
    const actionsView = collapse ? (
      <TldrCollapsableAction
        icon={<FaPlay />}
        action="play"
        callback={this.actionCallback}
        title={t("preview_effect")}
      ></TldrCollapsableAction>
    ) : (
      <>
        <TldrCollapsableAction
          icon={<FaPlay />}
          action="play"
          callback={this.actionCallback}
          title={t("preview_effect")}
        ></TldrCollapsableAction>
        <TldrCollapsableAction
          icon={<FaEdit />}
          action="edit"
          callback={this.actionCallback}
          title={t("edit", { ns: "common" })}
        ></TldrCollapsableAction>
        <TldrCollapsableAction
          icon={<FaTrash />}
          action="delete"
          callback={this.actionCallback}
          title={t("delete", { ns: "common" })}
        ></TldrCollapsableAction>
      </>
    );

    return (
      <div>
        <div className="title">
          {t("select_motion_name", { motionName: this.props.title })}
        </div>
        <StyledAdvEditorToolbarRow margin="0 0 0.5rem 0">
          <StudioAnimationCollection
            type={selectedTab}
            current={animationType ?? "none"}
            onClick={onChangeAnimation}
            source="layer"
            objectType={editor.activeElement.mime}
          />
        </StyledAdvEditorToolbarRow>
        {variants && (
          <StyledAdvEditorToolbarRow>
            <StyledAdvEditorToolbarFormatGroup mb="1rem">
              <div className="title">{t("direction")}</div>
              <ButtonGroup isAttached>{variants}</ButtonGroup>
            </StyledAdvEditorToolbarFormatGroup>
          </StyledAdvEditorToolbarRow>
        )}
        {animation && (
          <>
            <StyledAdvEditorToolbarRow>
              <StyledAdvEditorToolbarFormatGroup mb="1rem">
                <div className="title">
                  {t("animation_speed")}
                  {trans_duration && `(${trans_duration}ms)`}
                </div>
                <ButtonGroup isAttached>{presetOptions}</ButtonGroup>
              </StyledAdvEditorToolbarFormatGroup>
            </StyledAdvEditorToolbarRow>

            <StyledAdvEditorToolbarRow margin="0 0 1rem 0">
              <StyledAdvEditorToolbarFormatGroup>
                <div className="title">{t("easing")}</div>
                <TldrAnimationOptions
                  options={easingOptions}
                  value={easing}
                  onChange={this.onEasingChange}
                />
              </StyledAdvEditorToolbarFormatGroup>
            </StyledAdvEditorToolbarRow>
            <StyledAdvEditorToolbarRow margin="0 0 1rem 0">
              <StyledAdvEditorToolbarFormatGroup
                style={{ marginRight: "0.5rem" }}
              >
                <div className="title">{t("loop")}</div>
                <div className="actions">
                  <Switch
                    onChange={this.onLoopSwitchChange}
                    isChecked={this.state.checked}
                  />
                </div>
              </StyledAdvEditorToolbarFormatGroup>
            </StyledAdvEditorToolbarRow>
          </>
        )}
      </div>
    );
  }
}

StudioLayerAnimationControls.defaultProps = {
  allAnimations: [],
};

StudioLayerAnimationControls.propTypes = {
  editor: PropTypes.object.isRequired,
  layers: PropTypes.object.isRequired,
  onChangeAnimation: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
  allAnimations: PropTypes.array,
};

const mapStateToProps = (state) => ({
  editor: state.editor,
  layers: state.layerstore.layers,
  pages: state.pagestore.pages,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPlayingAnimation: (payload) =>
    dispatch(setCurrentPlayingAnimation(payload)),
});

export default withTranslation(["studio", "common"])(
  connect(mapStateToProps, mapDispatchToProps)(StudioLayerAnimationControls)
);
